// extracted by mini-css-extract-plugin
export default {"groupsPageContainer":"Groups_groupsPageContainer__jQwI2","tabsContainer":"Groups_tabsContainer__wfvTy"};